import type { ReactNode } from "react";

import { classes, Icon, Link } from "@alpacahq/ui/old";

interface NewWindowLinkProps {
  className?: string;
  to: string;
  children: ReactNode;
  hasIcon?: boolean;
  onClick?: () => void;
}

export const NewWindowLink = ({
  className,
  to,
  children,
  hasIcon = true,
  onClick,
}: NewWindowLinkProps) => {
  const handleClick = () => {
    window.open(to);
    onClick?.();
  };

  return (
    <Link className={classes("flex", className)} onClick={handleClick}>
      {children}
      {hasIcon ? (
        <Icon name="ArrowTopRightOnSquare" className="ml-0.5 pb-0.5" />
      ) : null}
    </Link>
  );
};

export default NewWindowLink;
